import React from 'react';
import { fonts, link } from '../../assets/jss';

const styles = {
    link: {
        ...fonts.secondary,
        ...link,
        fontSize: '1.3rem'
    },
    sub: {
        fontSize: '1.3rem'
    }
}

const Link = ({ title, href, text }) => (
    <sub style={{ ...styles.sub }}>{title} {" "}
        <a href={href}
            target="_blank"
            style={{ ...styles.link }}
            rel="noreferrer noopener">{text}</a>
    </sub>
)

export default Link

export const PrivacyPolicy = () => {
    return (
        <Link href={"https://www.websitepolicies.com/policies/view/LNIc3FSY"} text={`Privacy policy`} />
    )
}
export const Copyright = () => {
    return (
        <Link title={`Copyright © 2020`} href={"https://roscoe-vanderboom.web.app/"} text={`Roscoe van der Boom`} />
    )
}